import { useNavigate, useLocation } from 'react-router-dom';
import { RegistrationScreen } from '@/components/utils/RegistrationScreen';
import * as P from '@/constants/paths';

export const ResetPasswordExpired = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Get error message and email from navigation state
  const errorMessage = location.state?.errorMessage || 'The link has expired';
  const email = location.state?.email || '';

  const handleResetPassword = () => {
    navigate(P.PASSWORD_RECOVERY_PATH, {
      state: { email },
    });
  };

  const handleLogin = () => {
    navigate(P.LOGIN_PATH);
  };

  return (
    <RegistrationScreen
      title={errorMessage}
      description="To reset password, please request a new link"
      content={<div className="mt-8" data-testid="resetPasswordExpired-content" />}
      actionContainerClassName="w-[361px] mx-auto mb-4"
      primaryActionLabel="Reset password"
      primaryActionOnClick={handleResetPassword}
      secondaryActionLabel="Login"
      secondaryActionOnClick={handleLogin}
      hideBackButton
      data-testid="resetPasswordExpired-screen"
    />
  );
};
